import { render } from "./VoucherTracking.vue?vue&type=template&id=827fd824"
import script from "./VoucherTracking.vue?vue&type=script&lang=js"
export * from "./VoucherTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__